import React from 'react';
import { useIntl } from 'react-intl';

// components

import { Modal } from 'app-components';
import { GIButton } from 'app-components';

// props

interface IUnblockUserModalProps {
    onClose: () => void;
    onContinue: () => void;
}

function UnblockUserModal({ onClose, onContinue }: IUnblockUserModalProps) {
    const intl = useIntl();
    
    return (
        <Modal id='unblock_user_modal'>
            <Modal.Header id='unblock_user_modal_title' titleId='admin.member.view.side.nav.unblock_user' onHide={onClose} />
            <Modal.Body>
                <div className="text-center">
                    <strong>{intl.formatMessage({id: 'admin.member.unblock.user.desc'})}</strong>
                </div>
            </Modal.Body>
            <Modal.Controls>
                <div className='float-left'>
                    <GIButton id='cancel' labelId='button.cancel' variant='secondary' onClickHandler={onClose}></GIButton>
                </div>    
                <GIButton id='continue' labelId='button.continue' onClickHandler={onContinue}></GIButton>
            </Modal.Controls>
        </Modal>
    );
}

export default UnblockUserModal;